import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationStyleDirective } from './validation-style.directive';
import { ValidationMessagesComponent } from './validation-messages.component';
import { ValidationMessageDirective } from './validation-message.directive';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ValidationStyleDirective,
    ValidationMessagesComponent,
    ValidationMessageDirective
  ],
  exports: [
    ValidationStyleDirective,
    ValidationMessagesComponent,
    ValidationMessageDirective,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FormsExtensionsModule { }



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/forms/forms-extensions.module.ts